import { render, staticRenderFns } from "./settlement_detail.vue?vue&type=template&id=1e87c2b0&scoped=true"
import script from "./settlement_detail.vue?vue&type=script&lang=js"
export * from "./settlement_detail.vue?vue&type=script&lang=js"
import style0 from "./settlement_detail.vue?vue&type=style&index=0&id=1e87c2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87c2b0",
  null
  
)

export default component.exports